import { z } from 'zod'
// Terminal pipeline cards (completed / rejected) drop off the board once their
// status change is older than this. Keeps the board focused on recent activity.
export const STALE_TERMINAL_DAYS = 30 as const

export const CURRENCIES = ['EUR', 'RON', 'USD'] as const
export const ZodCurrency = z.enum(CURRENCIES)
export type Currency = z.infer<typeof ZodCurrency>

export const ZodDateLike = z.union([z.date(), z.string()])
export type DateLike = z.infer<typeof ZodDateLike>

// Notification types — must match the existing `notification_type` PG enum.
export const NOTIFICATION_TYPES = [
  'new_bid',
  'bid_accepted',
  'bid_rejected',
  'transport_status',
  'document_expiring',
  'company_approved',
  'company_rejected',
] as const
export const ZodNotificationType = z.enum(NOTIFICATION_TYPES)
export type NotificationType = z.infer<typeof ZodNotificationType>

export const ZodLocationRef = z.object({
  id: z.number(),
  city: z.string(),
  county: z.string().nullable(),
  country_code: z.string(),
  latitude: z.number(),
  longitude: z.number(),
})
export type LocationRef = z.infer<typeof ZodLocationRef>

export const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB
export const ALLOWED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp']
export const ALLOWED_DOCUMENT_TYPES = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg']

// Load types
export const LOAD_TYPES = ['FTL', 'LTL'] as const
export type LoadType = (typeof LOAD_TYPES)[number]

// Load statuses
export const LOAD_STATUSES = [
  'draft',
  'active',
  'has_bids',
  'accepted',
  'in_transport',
  'delivered',
  'closed',
  'expired',
  'cancelled',
] as const
export type LoadStatus = (typeof LOAD_STATUSES)[number]

// Bid statuses
export const BID_STATUSES = [
  'pending',
  'accepted',
  'rejected',
  'withdrawn',
  'expired',
  'cancelled',
] as const
export type BidStatus = (typeof BID_STATUSES)[number]

// Vehicle types
export const VEHICLE_TYPES = [
  'truck',
  'semi',
  'van',
  'refrigerated',
  'tilt',
  'mega_tilt',
  'box',
  'frigo',
  'flatbed',
  'container',
  'tanker',
  'car_carrier',
  'lowboy',
  'tipper',
  'oversized',
  'liquid_tanker',
] as const
export type VehicleType = (typeof VEHICLE_TYPES)[number]

// Vehicle statuses
export const VEHICLE_STATUSES = ['active', 'idle', 'maintenance', 'retired'] as const
export type VehicleStatus = (typeof VEHICLE_STATUSES)[number]

// Container sizes
export const CONTAINER_SIZES = ['20ft', '40ft'] as const
export type ContainerSize = (typeof CONTAINER_SIZES)[number]
